var render = function render(){var _vm=this,_c=_vm._self._c;return _c('grid-col',_vm._g({class:_vm.componentClasses,attrs:{"col":"6"}},_vm.$listeners),[_c('icon-play-triangle'),_c('text-body-small',{attrs:{"size":'sm2',"lineHeight":'multi'}},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }